
import { Injectable } from '@angular/core';
import { MRIEditerComponent } from 'src/app/MRIEditer';

@Injectable()
export class ExitGuard  {
  canDeactivate(component: MRIEditerComponent): boolean {
    return component.canDeactivate();
  }
}
